module.exports = __webpack_public_path__ + "img/algorand_logo_mark_black.6c6f52b0.svg";